export default function BacktestSetupMock() {
  return (
    <div className="platform-mock mock-sidebar">
      <div className="platform-mock-header"><span className="dot" /> Market</div>
      <div className="platform-mock-body">
        <div className="mock-sidebar-section">
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Mode</span>
            <span className="mock-toggle">
              <span className="mock-toggle-opt active">Single</span>
              <span className="mock-toggle-opt">Baseline</span>
            </span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Symbol</span>
            <span className="mock-sidebar-val">BTCUSDT <span className="mock-sidebar-link">Change</span></span>
          </div>
          <div className="mock-sidebar-row">
            <span className="mock-sidebar-label">Interval</span>
            <span className="mock-sidebar-val">1 Day <span className="mock-sidebar-link">Change</span></span>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">Select an asset and candle interval. Switch to Baseline mode to test across multiple assets at once.</div>
    </div>
  );
}
